import { render } from "./RevievsPage.vue?vue&type=template&id=24843a8e&scoped=true"
import script from "./RevievsPage.vue?vue&type=script&lang=js"
export * from "./RevievsPage.vue?vue&type=script&lang=js"

import "./RevievsPage.vue?vue&type=style&index=0&id=24843a8e&scoped=true&lang=scss"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24843a8e"]])

export default __exports__